"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryToSortChildren = exports.sortDESCbyWeight = exports.orderSolutions = exports.isWithinSameModule = exports.getVisibleMenuNodes = exports.getPathFromLink = void 0;
const sortDESCbyWeight = (a = {}, b = {}) => {
  var _a$meta;
  if (a.weight === b.weight && a !== null && a !== void 0 && (_a$meta = a.meta) !== null && _a$meta !== void 0 && _a$meta.default) {
    return -1;
  }
  return b.weight - a.weight;
};
exports.sortDESCbyWeight = sortDESCbyWeight;
const tryToSortChildren = item => item.children ? {
  ...item,
  children: orderSolutions(item.children)
} : item;
exports.tryToSortChildren = tryToSortChildren;
const orderSolutions = items => items.sort(sortDESCbyWeight).map(item => tryToSortChildren(item));
exports.orderSolutions = orderSolutions;
const isWithinSameModule = (targetLink = '', appPrefix) => {
  const currentPossibleRoute = `/${window.location.pathname.split('/')[1]}`;
  return appPrefix && targetLink.startsWith(appPrefix) || !appPrefix && targetLink.startsWith(currentPossibleRoute);
};
exports.isWithinSameModule = isWithinSameModule;
const getPathFromLink = (targetLink = '', appPrefix) => {
  if (!appPrefix || appPrefix === '/') {
    return targetLink;
  }
  return targetLink.replace(appPrefix, '');
};
exports.getPathFromLink = getPathFromLink;
const getVisibleMenuNodes = (nodes = []) => {
  return (nodes === null || nodes === void 0 ? void 0 : nodes.filter(node => {
    var _node$meta;
    return !(node !== null && node !== void 0 && (_node$meta = node.meta) !== null && _node$meta !== void 0 && _node$meta.appframeMenuHide);
  })) || [];
};
exports.getVisibleMenuNodes = getVisibleMenuNodes;